import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=295cbb68&"
import script from "./Development.vue?vue&type=script&lang=ts&"
export * from "./Development.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports